import { PortalEnvironment } from "./domain/portal.env";

export const environment: PortalEnvironment = {
  VERSION: "20250502.2-test",
  VERSION_URL: "https://transacciones.colsubsidio.com/portalempresas/ciam/qa/version",
  PRODUCTION: String("false") == "true",
  SALARIO_MINIMO: Number("1425000"),
  FEATURE_FLAGS: {
    RNEC: String('false') == "true"
  },
  NOTIFICACIONES_API: {
    PREFIJO_URL: "https://transacciones.colsubsidio.com/correos/api/v1",
    ENDPOINT_EMAIL: "/email?name=certificado_afiliacion.pdf"
  },
  LOCAL_STORAGE: {
    LOGIN_USER_TOKEN: "appLoginUserToken",
    BUSINESS_INFORMATION: "businessInformation",
    BUSINESS_NOTIFICATION_INFORMATION: "notification",
    AUTHORIZATION_TOKEN: "token",
    INFO_SHOW: "infoShow",
    USER_LOGGED_IN: "userloggedin",
    DATA_AFILIACION_USUARIO: "dataAffiliate",
    AFILIACION_MASIVA_ERRORES: "massResponseError",
    AFILIACION_MASIVA_NOMBRE_PLANTILLA_EXCEL: "name_file_mass",
    TRABAJADOR_INFORMACION: "workerInformation",
    TRABAJADOR_INFORMACION_FILTROS: "workerFilter",
    HISTORICO_AFILIACIONES_INFORMACION: "affiliateInformation",
    TRABAJADOR_INFORMACION_CRP: "crpworkerInformation",
    TRABAJADOR_INFORMACION_CUOTA_MONETARIA: "monetaryFee",
    CUOTA_MONETARIA_MOVIMIENTOS: "movementsMonetaryFee",
    BONO_ESCOLAR_MOVIMIENTOS: "movementsSchollAllowance",
    BONO_ESCOLAR_MOVIMIENTOS_DEBITO: "movementsDebitSchollAllowance",
    DESAFILIACION_INFORMACION: "disaffiliateInformation",
    CERTIFICADO_ESTADO_CUENTA_CUOTA_MONETARIA: "certificateStateAccountMonetary",
    GESTOR_CONTENIDO: "contentManager",
    CERTIFICADO_ESTADO_CUENTA_CUOTA_MONETARIA_FORMATO: "certificateStateAccountMonetaryFormat"
  },
  GESTOR_DE_CONTENIDO_URL: "https://app-empresas-gestion-gestor-dru-test.azurewebsites.net/gestor",
  BLOB_STORAGE_URL: "https://sttidev.blob.core.windows.net/portales-integracion/",
  SEGURIDAD: {
    CRYPT_SECRET: "1234",
    API_AUTENTICACION_URL: "http://40.117.63.112/authtransactional/api",
    API_LOGOUT_URL: "https://cdp-as-transversal-ssob-test.azurewebsites.net/api/transaccional",
    SSO_URL: "https://www.colsubsidio.com/ssob/#/ingresar?goto=http://localhost:4200"
  },
  CIAM_PREFIX: "ColsubB2B",
  CIAM_API_KEY: "4_9nsax5GbPCg5CRmjaMTBZw",
  CIAM_TYPE_MARKETING: "B2B",
  CIAM_VAR_USERDATA: "sso_empresa",
  CIAM_VAR_AUTHDATA: "decode-jwt-sso_empresa",
  CIAM_VAR_ORGANIZATION: "x-Colsubsidio-Organizacion-x",
  CIAM_API_VIEW_LITE: String('false') == "true",
  CIAM_API_PREFIX: "ColsubB2B",
  CIAM_API_CDN_URL: "https://loginqaemp.transacciones.colsubsidio.com",
  CIAM_URL_AUTHENTICATION_CIAM: "https://app-tra-auth-ciam-api-develop.azurewebsites.net/v1.0/authciam/signin",
  CIAM_COUNT_AUTH: Number('4'),
  URL_CONTEXT: "/portalempresas/ciam/qa",
  URL_LOGIN_CIAM: "https://loginqaemp.transacciones.colsubsidio.com/js/gigya.js?apiKey=4_9nsax5GbPCg5CRmjaMTBZw",
  URL_LOGIN_SESSION: "https://transacciones.colsubsidio.com/portalempresas/ciam/qa/#/login",
  AFILIACION_MASIVA: {
    BLOB_STORAGE_TOKEN: "?sv=2021-10-04&st=2023-07-25T16%3A45%3A45Z&se=2025-12-31T16%3A45%3A00Z&sr=b&sp=r&sig=YLHdQy7Dx7nnsqixdcSdhg832eM08NbXajiefaKMEBI%3D",
    API_URL: "https://app-emp-afiliacion-masiva-api-test.azurewebsites.net/v1.0",
    REPORTE_MASIVO_AUTH: "Ker67Wt?Az2Q3",
    REPORTE_MASIVO_API_URL: "https://app-emp-reporte-masivo-publicador-api-test.azurewebsites.net/v1.0",
    REPORTE_MASIVO_CONTEO: "https://app-emp-reporte-masivo-subscriptor-api-test.azurewebsites.net/v1.0",
    MANUAL_PDF_URL: ":AFILIACION_MASIVA_MANUAL_PDF_URL:",
    HISTORIAL_AFILIACION_API_URL: "https://cdp-as-portalempresas-afiliacion-histori-test.azurewebsites.net/v1.0"
  },
  GESTOR_SOLICITUDES: {
    API_CONSULTAS: {
      PREFIJO_URL: "https://app-trans-empresas-consultas-solicitudes-test.azurewebsites.net/v1.0",
      DOCUMENTOS_DIGITALES_ENDPOINT: "/request/documents?"
    },
    API_CLIENTE: {
      PREFIJO_URL: "https://app-trans-gestor-solicitudes-cliente-api-test.azurewebsites.net/v1.0"
    },
    API_AUTORIZADOR: {
      PREFIJO_URL: "https://app-trans-gestor-solicitudes-autorizador-test.azurewebsites.net/v1.0"
    }
  },
  DESAFILIACION_MASIVA: {
    BLOB_STORAGE_TOKEN: "?sv=2021-10-04&st=2023-07-27T13%3A01%3A27Z&se=2025-07-28T13%3A01%3A00Z&sr=b&sp=r&sig=IOWE38dLx%2FwWxxr%2B21%2FaYGwUPiUdfljnqiLYswshHbI%3D",
    PREFIJO_URL: "https://app-empresas-desafiliacion-masiva-api-test.azurewebsites.net/v1.0"
  },
  DESAFILIACION_INDIVIDUAL_API: {
    PREFIJO_URL: "https://app-empresas-desafiliacion-individual-ap-test.azurewebsites.net/v1.0"
  },
  RNEC_API: {
    PREFIJO_URL: "https://app-empresas-consulta-rnec-api-test.azurewebsites.net/v1.0/consulta/BI",
    VALIDAR_HIJO: "/validar-hijo"
  },
  CUOTA_MONETARIA: {
    ACREDITACION_API_PREFIJO_URL: "https://app-emp-acreditacion-cuota-monetaria-cliente-api-test.azurewebsites.net/v1.0/customer/",
    ACREDITACION_API_ENDPOINT_SOLICITUDES: "/solicitudes",
    ACREDITACION_API_ENDPOINT_SOLICITUDES_MASIVAS: "/solicitudes/masiva",
    ACREDITACION_API_ENDPOINT_ARCHIVOS_CARGAR: "/archivo/cargar/",
    ACREDITACION_API_ENDPOINT_ARCHIVOS_ELIMINAR: "/archivo/eliminar",
    ACREDITACION_API_PATH_FORMATO_AFILIACION: "/archivo/fomatos/afiliacion/",
    ACREDITACION_API_PATH_FORMATO_BAJO_JURAMENTO: "/archivo/fomatos/bajojuramento/",
    EMPRESAS_API: "https://cdp-as-portalempresas-cuota-monetaria-test.azurewebsites.net",
    EMPRESAS_CUOTA_SUBSIDIO_FAMILIAR_API: "https://app-emp-cuota-subsidio-familiar-api-test.azurewebsites.net/v1.0",
    PERSONAS_ESTADO_CUENTA_API: "https://api-personas-estado-cuenta-subsidio-fami-test.azurewebsites.net/v1.0/api/estado/cuenta/reporte"
  },
  AFILIACION: {
    INFORMACION_TRABABAJADOR_API: "https://cdp-as-portalempresas-descargar-infotrab-test.azurewebsites.net/api",
    VALIDADOR_EMPRESAS_API: "https://cdp-as-portalempresas-malla-valregistro-test.azurewebsites.net/api/transaccional/validationAffiliate",
    VALIDADOR_PERSONAS_API: "https://app-empresas-validador-afiliacion-api-test.azurewebsites.net/v1.0/api/transaccional/validationAffiliate",
    CERTIFICADOS_API: "https://cols-as-digprod-portalempresas-afiliacio-test.azurewebsites.net/api/transaccional/certificados"
  },
  SUBSIDIO_ESCOLAR: {
    API_URL: "https://app-emp-subsidio-escolar-api-test.azurewebsites.net/v1.0"
  },
  ORQUESTADOR: {
    API_URL: "https://cdp-portalempresas-orquestador-test.azurewebsites.net/api"
  },
  PQR_TPCLIENT_API_URL: "https://cdp-as-transversal-tpclient-manager-test.azurewebsites.net/v1.0",
  PQR_GESTION_API_URL: "https://app-emp-pqrs-gestion-api-test.azurewebsites.net/v1.0",
  PQR_ORGANIZATION_ID: "ACME",
  PQR_RELATION_ID: "CLCO1",
  PQR_RELATION_ID_OTROS: "ED",
  PQR_CUSTOMER_TYPE_ID: "S_CLIECO",
  PQR_CLASSIFIER_NIVEL_BASE: "COCLCO",
  PQR_CLASSIFIER_NIVEL_BASE_OTROS: "INOT",
  PQR_LANGUAGE: "es",
  PQR_SEARCH_TYPE: "3"
};
